// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkLikeButtonCss } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { orderStatusHeaderStyles } from "@conklin/Overrides/Widgets/OrderStatus/OrderStatusHeader";
import IconPrint from "@conklin/XDL/Icons/IconPrint";
import { generateButtonLinkStyle, mergeWithCss } from "@conklin/XDL/Utilities";
import Mail from "@insite/mobius/Icons/Mail";
import RotateCcw from "@insite/mobius/Icons/RotateCcw";
import { css } from "styled-components";

orderStatusHeaderStyles.buttonsGridItem = {
    width: 12,
    css: css`
        display: flex;
        justify-content: flex-start;
        gap: 16px 24px;
    `,
};

orderStatusHeaderStyles.printButton = {
    ...mergeWithCss(generateButtonLinkStyle(IconPrint), linkLikeButtonCss),
};

orderStatusHeaderStyles.shareEntityButtonStyles = {
    button: {
        ...mergeWithCss(generateButtonLinkStyle(Mail), linkLikeButtonCss),
    },
};

orderStatusHeaderStyles.reorderButton = {
    ...mergeWithCss(generateButtonLinkStyle(RotateCcw), linkLikeButtonCss),
};

orderStatusHeaderStyles.spinner = {
    size: 16,
};

orderStatusHeaderStyles.container = {
    gap: 5,
    css: css`
        margin-top: 0;
    `,
};
